import { useModalContext } from 'utils/contexts/modal';
import { useListsContext } from '../../../contexts';
import { useDeleteListMutation } from '../../../hooks';

export const useOnConfirmDelete = () => {
  const { hideModal } = useModalContext();
  const { listsToDelete, setListsToDelete, refetch } = useListsContext();
  const { deleteList } = useDeleteListMutation(listsToDelete[0]);

  return () => {
    deleteList();
    setListsToDelete([]);
    refetch();
    hideModal();
  };
};
